module.exports = __webpack_public_path__ + "static/img/6.318b27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Seguro-Colectivo/6.png
// module id = wA53
// module chunks = 0